var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "tool" }, [
                  _c("h4", [_vm._v("选择客户")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.customerChange },
                          model: {
                            value: _vm.customerValue,
                            callback: function($$v) {
                              _vm.customerValue = $$v
                            },
                            expression: "customerValue"
                          }
                        },
                        _vm._l(_vm.customerData, function(item) {
                          return _c("el-option", {
                            key: item.number,
                            attrs: {
                              label: item.number + item.client_name,
                              value: item.client_name
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "part" },
                  [
                    _c("h5", [_vm._v("选择毛坯图/手绘图")]),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.spaceChange },
                        model: {
                          value: _vm.spaceCur,
                          callback: function($$v) {
                            _vm.spaceCur = $$v
                          },
                          expression: "spaceCur"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "space_box" },
                          _vm._l(_vm.spaceData, function(item, index) {
                            return _c(
                              "el-radio",
                              {
                                key: "space" + index,
                                attrs: { label: item.space_type }
                              },
                              [_vm._v(_vm._s(item.space_type))]
                            )
                          }),
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.workblankData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "workblank_box" },
                          _vm._l(_vm.workblankData, function(item, index) {
                            return _c(
                              "div",
                              { key: "workblank" + index, staticClass: "item" },
                              [
                                _c("img", {
                                  attrs: { src: item.photo_url, alt: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.workblankClick(index)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "radio" },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: { label: index },
                                        model: {
                                          value: _vm.workblankCur,
                                          callback: function($$v) {
                                            _vm.workblankCur = $$v
                                          },
                                          expression: "workblankCur"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.spaceCur + (index + 1))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.workblankData.length <= 0
                      ? _c(
                          "div",
                          {},
                          [
                            _c(
                              "el-empty",
                              {
                                attrs: {
                                  "image-size": 50,
                                  description: "该空间类型暂时没有上传底图!"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success" },
                                    on: { click: _vm.toWorkblank }
                                  },
                                  [_vm._v("去上传")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("h5", [_vm._v("生成模式")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "generation_mode_box" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mode_btn",
                          attrs: {
                            type:
                              _vm.generationMode == "style"
                                ? "success"
                                : "default"
                          },
                          on: {
                            click: function($event) {
                              _vm.generationMode = "style"
                            }
                          }
                        },
                        [_vm._v("\n              叠加风格图生成\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mode_btn",
                          attrs: {
                            type:
                              _vm.generationMode == "prompt"
                                ? "success"
                                : "default"
                          },
                          on: {
                            click: function($event) {
                              _vm.generationMode = "prompt"
                            }
                          }
                        },
                        [_vm._v("\n              叠加提示词生成\n            ")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.generationMode == "style"
                  ? _c(
                      "div",
                      { staticClass: "part photo_box" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.collapseChange },
                            model: {
                              value: _vm.isCollapse,
                              callback: function($$v) {
                                _vm.isCollapse = $$v
                              },
                              expression: "isCollapse"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "style_type_box" },
                              [
                                _c("el-radio-button", {
                                  attrs: { label: "选择单张图" }
                                }),
                                _vm._v(" "),
                                _c("el-radio-button", {
                                  attrs: { label: "选择案例图" }
                                }),
                                _vm._v(" "),
                                _c("el-radio-button", {
                                  attrs: { label: "选择个人素材库" }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "material_btn" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", plain: "" },
                                on: { click: _vm.materialBtnClick }
                              },
                              [_vm._v("上传风格参考图")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isCollapse == "选择单张图"
                          ? _c(
                              "div",
                              {},
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          "padding-right": "20px"
                                        },
                                        attrs: { span: 4 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "label",
                                            attrs: {
                                              type: "success",
                                              effect: "light"
                                            }
                                          },
                                          [_vm._v("风格")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "tag_main",
                                        attrs: { span: 20 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: "all_item",
                                            attrs: {
                                              type:
                                                -1 == _vm.styleNum
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.styleClick(-1)
                                              }
                                            }
                                          },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.styleData, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: "style" + index,
                                              attrs: {
                                                type:
                                                  index == _vm.styleNum
                                                    ? "success"
                                                    : "info",
                                                effect: "light"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.styleClick(index)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.style_type))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          "padding-right": "20px"
                                        },
                                        attrs: { span: 4 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "label",
                                            attrs: {
                                              type: "success",
                                              effect: "light"
                                            }
                                          },
                                          [_vm._v("空间类型")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "tag_main",
                                        attrs: { span: 20 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: "all_item",
                                            attrs: {
                                              type:
                                                -1 == _vm.spaceNum
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.spaceClick(-1)
                                              }
                                            }
                                          },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.spaceData, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: "space" + index,
                                              attrs: {
                                                type:
                                                  index == _vm.spaceNum
                                                    ? "success"
                                                    : "info",
                                                effect: "light"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.spaceClick(index)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.space_type))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCollapse == "选择案例图"
                          ? _c(
                              "div",
                              {},
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          "padding-right": "20px"
                                        },
                                        attrs: { span: 4 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "label",
                                            attrs: {
                                              type: "success",
                                              effect: "light"
                                            }
                                          },
                                          [_vm._v("公司案例")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "tag_main",
                                        attrs: { span: 20 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: "all_item",
                                            attrs: {
                                              type:
                                                -1 == _vm.companyCur
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.companyClick(-1)
                                              }
                                            }
                                          },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.companyData, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: "company" + index,
                                              attrs: {
                                                type:
                                                  index == _vm.companyCur
                                                    ? "success"
                                                    : "info",
                                                effect: "light"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.companyClick(index)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.project_type))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          "padding-right": "20px"
                                        },
                                        attrs: { span: 4 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "label",
                                            attrs: {
                                              type: "success",
                                              effect: "light"
                                            }
                                          },
                                          [_vm._v("项目案例")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "tag_main",
                                        attrs: { span: 20 }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: "all_item",
                                            attrs: {
                                              type:
                                                -1 == _vm.projectCur
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.projectClick(-1)
                                              }
                                            }
                                          },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.projectData, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: "project" + index,
                                              attrs: {
                                                type:
                                                  index == _vm.projectCur
                                                    ? "success"
                                                    : "info",
                                                effect: "light"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.projectClick(index)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.project_type))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.materialData.length > 0 &&
                        _vm.isCollapse != "上传风格参考图"
                          ? _c(
                              "div",
                              { staticClass: "material_box" },
                              [
                                _c(
                                  "waterfall",
                                  {
                                    staticClass: "material_main",
                                    attrs: {
                                      height: "300px",
                                      col: 5,
                                      gutterWidth: 20,
                                      data: _vm.materialData,
                                      lazyDistance: 200,
                                      loadDistance: 100
                                    },
                                    on: { loadmore: _vm.getMaterial }
                                  },
                                  [
                                    _vm._l(_vm.materialData, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "meterial" + index,
                                          staticClass: "item"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.photo_url +
                                                "?x-oss-process=image/resize,w_300",
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toDetail(index)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.isCollapse != "选择案例图"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "radio",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.materialClick(
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: index },
                                                      model: {
                                                        value: _vm.materialCur,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.materialCur = $$v
                                                        },
                                                        expression:
                                                          "materialCur"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.style_type +
                                                            (index + 1)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isCollapse == "选择案例图"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "radio project_radio",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.materialClick(
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: index },
                                                      model: {
                                                        value: _vm.materialCur,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.materialCur = $$v
                                                        },
                                                        expression:
                                                          "materialCur"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.project_name
                                                        ) +
                                                          "\n                      "
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "project_radio_label"
                                                        },
                                                        _vm._l(
                                                          item.tag,
                                                          function(
                                                            itemS,
                                                            indexS
                                                          ) {
                                                            return _c("span", [
                                                              _vm._v(
                                                                _vm._s(itemS) +
                                                                  _vm._s(
                                                                    indexS <
                                                                      item.tag
                                                                        .length -
                                                                        1
                                                                      ? " / "
                                                                      : ""
                                                                  )
                                                              )
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.materialData.length <= 0
                          ? _c(
                              "div",
                              {},
                              [
                                _c("el-empty", {
                                  attrs: {
                                    "image-size": 50,
                                    description: "暂无数据"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCollapse == "上传风格参考图"
                          ? _c(
                              "div",
                              {},
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "",
                                      "show-file-list": false,
                                      multiple: "",
                                      "http-request": _vm.uploadImage
                                    }
                                  },
                                  [
                                    _vm.uploadImg
                                      ? _c("img", {
                                          staticClass: "avatar",
                                          attrs: { src: _vm.uploadImg }
                                        })
                                      : _c("el-button", {
                                          attrs: { icon: "el-icon-plus" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.generationMode == "prompt"
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("提示词输入")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "prompt_input_box" }, [
                        _c("div", { staticClass: "cue_word" }, [
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  placeholder: "请输入内容",
                                  resize: "none"
                                },
                                model: {
                                  value: _vm.zh_content,
                                  callback: function($$v) {
                                    _vm.zh_content = $$v
                                  },
                                  expression: "zh_content"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "lexicon" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "small",
                                        plain: ""
                                      },
                                      on: { click: _vm.toLexicon }
                                    },
                                    [_vm._v("提示词库")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "translate" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "small",
                                        loading: _vm.expandLoading,
                                        plain: ""
                                      },
                                      on: { click: _vm.goLexicon }
                                    },
                                    [_vm._v("AI扩写润色")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.generationMode == "style"
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("AI大模型")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {},
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.aiCur,
                                callback: function($$v) {
                                  _vm.aiCur = $$v
                                },
                                expression: "aiCur"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ai_box" },
                                _vm._l(_vm.aiData, function(item, index) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: "ai" + index,
                                      attrs: { label: item.model_id }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.model_name +
                                            "(" +
                                            item.price +
                                            ")"
                                        )
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h6", [
                        _vm._v("提示词 "),
                        _vm.isNanoBananaModel
                          ? _c(
                              "span",
                              {
                                staticClass: "nanobanana_warning",
                                on: { click: _vm.showNanoBananaInfo }
                              },
                              [
                                _vm._v(
                                  "此模型极度依赖提示词！点击查看提示词技巧"
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "para_part" }, [
                        _c("div", { staticClass: "ai_para_box" }, [
                          _c("div", { staticClass: "cue_word" }, [
                            _c(
                              "div",
                              { staticClass: "item" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 5,
                                    placeholder: "请输入提示词",
                                    resize: "none"
                                  },
                                  model: {
                                    value: _vm.stylePrompt,
                                    callback: function($$v) {
                                      _vm.stylePrompt = $$v
                                    },
                                    expression: "stylePrompt"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "lexicon" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                          plain: ""
                                        },
                                        on: { click: _vm.toStyleLexicon }
                                      },
                                      [_vm._v("提示词库")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "translate" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                          loading: _vm.styleExpandLoading,
                                          plain: ""
                                        },
                                        on: { click: _vm.goStyleLexicon }
                                      },
                                      [_vm._v("AI扩写润色")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isStabilityModel
                            ? _c("div", { staticClass: "intensity_sliders" }, [
                                _c(
                                  "div",
                                  { staticClass: "slider_item" },
                                  [
                                    _c("div", { staticClass: "slider_label" }, [
                                      _c("span", [_vm._v("风格强度")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "slider_value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.styleIntensity) + "%"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-slider", {
                                      attrs: { min: 0, max: 100, step: 1 },
                                      model: {
                                        value: _vm.styleIntensity,
                                        callback: function($$v) {
                                          _vm.styleIntensity = $$v
                                        },
                                        expression: "styleIntensity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "slider_item" },
                                  [
                                    _c("div", { staticClass: "slider_label" }, [
                                      _c("span", [_vm._v("描述强度")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "slider_value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.describeIntensity) + "%"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-slider", {
                                      attrs: { min: 10, max: 100, step: 10 },
                                      model: {
                                        value: _vm.describeIntensity,
                                        callback: function($$v) {
                                          _vm.describeIntensity = $$v
                                        },
                                        expression: "describeIntensity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.generationMode == "prompt"
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("AI大模型")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {},
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.aiEditCur,
                                callback: function($$v) {
                                  _vm.aiEditCur = $$v
                                },
                                expression: "aiEditCur"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ai_box" },
                                _vm._l(_vm.aiEditData, function(item, index) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: "aiedit" + index,
                                      attrs: { label: item.model_id }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.model_name +
                                            "(" +
                                            item.price +
                                            ")"
                                        )
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.generationMode != ""
                  ? _c(
                      "div",
                      { staticClass: "btn_save" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { type: "success" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("立即生成")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "prompt" }, [
                          _vm._v(
                            "（本月剩余使用额度 " +
                              _vm._s(_vm.global.money) +
                              "元）"
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resultStatus != 0
                  ? _c("div", { staticClass: "effect_box" }, [
                      _vm.resultStatus == 2
                        ? _c("div", { staticClass: "complete" }, [
                            _c("div", { staticClass: "cur" }, [
                              _c("img", {
                                attrs: { src: _vm.effectUrl, alt: "" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "list" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function($event) {
                                      return _vm.effectClick(0)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.workblankData[_vm.workblankCur]
                                          .photo_url +
                                        "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v("底图")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.generationMode == "style"
                                ? _c("div", { staticClass: "item plus" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.generationMode == "style"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      on: {
                                        click: function($event) {
                                          return _vm.effectClick(1)
                                        }
                                      }
                                    },
                                    [
                                      _vm.isCollapse != "上传风格参考图"
                                        ? _c("img", {
                                            attrs: {
                                              src:
                                                _vm.materialData[
                                                  _vm.materialCur
                                                ].photo_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isCollapse == "上传风格参考图"
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.uploadImg,
                                              alt: ""
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v("参考图")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.generationMode == "prompt"
                                ? _c("div", { staticClass: "item plus" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.generationMode == "prompt"
                                ? _c(
                                    "div",
                                    { staticClass: "item prompt_display" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "prompt_text" },
                                        [_vm._v(_vm._s(_vm.zh_content))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v("提示词")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "item equal" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item effect",
                                  on: {
                                    click: function($event) {
                                      return _vm.effectClick(2)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.effectData[0].file_url +
                                        "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v("效果图")
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tools" }, [
                              _c(
                                "div",
                                { staticClass: "btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-refresh"
                                      },
                                      on: { click: _vm.toNew }
                                    },
                                    [_vm._v("生成新的效果图")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-video-camera"
                                      },
                                      on: { click: _vm.toVideo }
                                    },
                                    [_vm._v("图生视频")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-edit-outline"
                                      },
                                      on: { click: _vm.toEdit }
                                    },
                                    [_vm._v("AI改图")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon:
                                          _vm.favoriteType == true
                                            ? "el-icon-star-off"
                                            : "el-icon-star-on"
                                      },
                                      on: { click: _vm.toFavorite }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.favoriteType == true
                                            ? "收藏"
                                            : "取消收藏"
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-download"
                                      },
                                      on: { click: _vm.toDownload }
                                    },
                                    [_vm._v("下载")]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resultStatus == 1
                        ? _c(
                            "div",
                            { staticClass: "progress" },
                            [
                              _c("el-progress", {
                                attrs: { percentage: _vm.percent }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogCur != -1
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: { src: _vm.detailImg, alt: "" }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "lexicon"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        "custom-class": "lexicon_box",
                        top: "15vh",
                        "show-close": true,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeIndex,
                            mode: "horizontal"
                          },
                          on: { select: _vm.handleSelect }
                        },
                        _vm._l(_vm.lexiconLabelData, function(item, index) {
                          return _c(
                            "el-menu-item",
                            {
                              key: "lexiconLabel" + index,
                              attrs: { index: index.toString() }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lexicon_list" },
                        [
                          _vm.lexiconData[_vm.activeIndex].length > 0
                            ? _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.lexiconCheckList,
                                    callback: function($$v) {
                                      _vm.lexiconCheckList = $$v
                                    },
                                    expression: "lexiconCheckList"
                                  }
                                },
                                _vm._l(
                                  _vm.lexiconData[_vm.activeIndex],
                                  function(item, index) {
                                    return _c("el-checkbox", {
                                      key: "lexicon" + index,
                                      attrs: { label: item.word }
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lexiconData[_vm.activeIndex].length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lexiconCheckList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "choose_list" },
                            _vm._l(_vm.lexiconCheckList, function(item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: "choose" + index,
                                  attrs: {
                                    closable: true,
                                    "disable-transitions": true,
                                    type: "success"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.handleClose(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4, offset: 19 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.confirmLexicon }
                                },
                                [_vm._v("确定")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "styleLexicon"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        "custom-class": "lexicon_box",
                        top: "15vh",
                        "show-close": true,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeIndex,
                            mode: "horizontal"
                          },
                          on: { select: _vm.handleSelect }
                        },
                        _vm._l(_vm.lexiconLabelData, function(item, index) {
                          return _c(
                            "el-menu-item",
                            {
                              key: "styleLexiconLabel" + index,
                              attrs: { index: index.toString() }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lexicon_list" },
                        [
                          _vm.lexiconData[_vm.activeIndex].length > 0
                            ? _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.lexiconCheckList,
                                    callback: function($$v) {
                                      _vm.lexiconCheckList = $$v
                                    },
                                    expression: "lexiconCheckList"
                                  }
                                },
                                _vm._l(
                                  _vm.lexiconData[_vm.activeIndex],
                                  function(item, index) {
                                    return _c("el-checkbox", {
                                      key: "styleLexicon" + index,
                                      attrs: { label: item.word }
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lexiconData[_vm.activeIndex].length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lexiconCheckList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "choose_list" },
                            _vm._l(_vm.lexiconCheckList, function(item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: "styleChoose" + index,
                                  attrs: {
                                    closable: true,
                                    "disable-transitions": true,
                                    type: "success"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.handleClose(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4, offset: 19 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.confirmStyleLexicon }
                                },
                                [_vm._v("确定")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "case_detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        width: "90%",
                        "custom-class": "case_box",
                        "show-close": true,
                        center: true,
                        closeDetail: _vm.closeCaseDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "detail_box row",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c("el-col", { attrs: { span: 14 } }, [
                            _vm.dialogCur != -1
                              ? _c("div", { staticClass: "img" }, [
                                  _c(
                                    "div",
                                    { staticClass: "swiper-container" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "swiper mySwiper2",
                                          staticStyle: {
                                            "--swiper-navigation-color": "#fff",
                                            "--swiper-pagination-color": "#fff"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "swiper-wrapper" },
                                            _vm._l(
                                              _vm.detailData.photo,
                                              function(item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.photo_url,
                                                    staticClass: "swiper-slide"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.photo_url
                                                      }
                                                    })
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "swiper-button-next"
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "swiper-button-prev"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "swiper mySwiper",
                                          attrs: { thumbsSlider: "" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "swiper-wrapper" },
                                            _vm._l(
                                              _vm.detailData.photo,
                                              function(item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.photo_url,
                                                    staticClass: "swiper-slide"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.photo_url
                                                      }
                                                    })
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.dialogCur != -1
                            ? _c("el-col", { attrs: { span: 10 } }, [
                                _c("div", { staticClass: "list" }, [
                                  _c("div", { staticClass: "item title" }, [
                                    _vm._v(_vm._s(_vm.detailData.company))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.detailData.design_concept) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("项目名称")
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(_vm.detailData.project_name)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("项目地址")
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(_vm.detailData.project_address)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("项目面积")
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(_vm.detailData.project_area) +
                                          "平方米"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("标签类型")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "content" },
                                      _vm._l(_vm.detailData.tag, function(
                                        value,
                                        index
                                      ) {
                                        return _c("span", [
                                          index == _vm.detailData.tag.length - 1
                                            ? _c("span", [
                                                _vm._v(_vm._s(value))
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          index < _vm.detailData.tag.length - 1
                                            ? _c("span", [
                                                _vm._v(_vm._s(value) + " / ")
                                              ])
                                            : _vm._e()
                                        ])
                                      }),
                                      0
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("项目类型")
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content date" }, [
                                      _vm._v(
                                        _vm._s(_vm.detailData.project_type)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.projectCur != -1
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("div", { staticClass: "label" }, [
                                          _vm._v("设计师")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "content date" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detailData.designer)
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.showNanoBananaInfoDialog,
                    width: "auto",
                    "show-close": true,
                    center: true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.showNanoBananaInfoDialog = $event
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "max-width": "80vw", "max-height": "80vh" },
                    attrs: { src: "/static/info.png", alt: "提示词技巧" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ceefdcde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceefdcde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/Save.vue
// module id = null
// module chunks = 